import React from 'react';

class TechSpecs extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="rel tech__container bcg">
        <div className="container--xl ma">
          <div className="f jcb aic fw tech__flex">
            <div className="container--xl ma rel z2 p15 tech__text">
              <h4 className="caps">{data.title}</h4>
              <p className="s20">{data.description}</p>
              <div className="quick__items f fw container--m jcs ais">
                {data.listItems.map(item => (
                  <div key={Math.random()}>
                    <h5 className="caps akkura mb05 ls">{item.fields.title}</h5>
                    <h5 className="m0 caps akkura p0">
                      {item.fields.supportingText}
                    </h5>
                  </div>
                ))}
              </div>
            </div>
            <div className="container--xl ma rel p15 tech__image">
              <img src={data.image.fields.file.url} className="" alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TechSpecs;
